/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolAnnotations,
  ToolAnnotations$inboundSchema,
} from "./toolannotations.js";

export type RiskMCPPlatformTool = {
  /**
   * Tool annotations providing behavioral hints about the tool
   */
  annotations?: ToolAnnotations | undefined;
  /**
   * The Platform MCP tool name.
   */
  name: string;
};

/** @internal */
export const RiskMCPPlatformTool$inboundSchema: z.ZodMiniType<
  RiskMCPPlatformTool,
  unknown
> = z.object({
  annotations: z.optional(ToolAnnotations$inboundSchema),
  name: z.string(),
});

export function riskMCPPlatformToolFromJSON(
  jsonString: string,
): SafeParseResult<RiskMCPPlatformTool, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskMCPPlatformTool$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskMCPPlatformTool' from JSON`,
  );
}
